import { Flex } from "@chakra-ui/react";
import TableList from "components/TableList";
import DropDown from "components/DropDown";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { api } from "services/api";
import utils from "utils";
import constant from "constant";
import { Header } from "components/Header";
import PaginationComp from "components/PaginationComp";
import SearchInput from "components/SearchInput";
import ButtonComp from "components/Button";
import storage from "utils/storage";
import Modal from "../../components/Modal";
import CardAmount from "components/CardAmount";

const paidId = utils.getStateId("Paid", "invoice");

const headers = [
  "Invoice Number",
  "State",
  "Date",
  "Paid",
  "By",
  "Retailer",
  "Details",
  {
    label: "Gross (£)",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  // "Actions",
];

const PaymentIframe = ({ itemData }) => {
  const payingInvoice = itemData;
  if (!payingInvoice) return null;

  const iframeSrc = `https://payments.auwarranties.co.uk/data/?amount=${payingInvoice.gross}&currency=GBP&currency_symbol=%C2%A3&invoice_number=${payingInvoice.invoicenumber}&invoiceid=${payingInvoice.invoiceid}&userid=${payingInvoice.userid}&stripe_customerid=${payingInvoice.stripe_customerid}&payment_operator=${payingInvoice.payment_operator}`;

  return (
    <iframe
      src={iframeSrc}
      width="100%"
      height="600px"
      title="Payment"
      allow="payment"
    />
  );
};

function Invoices() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);
  const [searchTxt, setSearchTxt] = useState("");

  const [datesDd, setDatesDd] = useState([]);
  const [date, setDate] = useState("");

  const [dealers, setDealers] = useState();

  const [ttlInvoice, setTtlInvoice] = useState(0);
  const [ttlInvoiceVat, setTtlInvoiceVat] = useState(0);
  const [ttlPaid, setTtlPaid] = useState(0);
  const [ttlPaidVat, setTtlPaidVat] = useState(0);
  const [ttlPending, setTtlPending] = useState(0);
  const [ttlPendingVat, setTtlPendingVat] = useState(0);

  const [filerLast, setFilerLast] = useState([]);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [payingInvoice, setPayingInvoice] = useState(null);

  const loginRes = storage.get("loginRes");

  const onRunAgain = async () => {
    const selectedItem2 = JSON.parse(JSON.stringify(selectedItem || {}));
    setSelectedItem();

    setIsLoading(true);
    const res = await api.runagainInvoice({
      invoiceid: selectedItem2?.item?.data?.invoiceid,
      invoicenumber: selectedItem2?.item?.data?.invoicenumber,
    });
    setIsLoading(false);

    if (res?.status === 200) {
      getList();
    }
    console.log("onRunAgain", res);

    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });
    return;
  };

  const genPl = (data) => {
    const pl = {
      date: data?.date || date || "",
      dealerid: data?.dealerid ?? utils.getDealerid(dealers),
      searchTxt: "",
      limitId: data?.limitId || utils.getLimitId(filerLast),
      page: data?.page || activePage,
    };

    pl.searchTxt = data?.searchTxt === undefined ? searchTxt : data.searchTxt;

    if (data?.date === "-1") {
      pl.date = "";
    }

    return pl;
  };

  const onPrint = async ({ isallprint, data }) => {
    const selectedItem2 = JSON.parse(JSON.stringify(selectedItem || {}));
    setSelectedItem();

    setIsLoading(true);
    const res = await api.getInvoiceprint({
      ...genPl(),
      invoiceid: selectedItem2?.item?.data?.invoiceid,
      isallprint: isallprint,
    });
    setIsLoading(false);
    if (res?.status === 200) {
      if (res?.data?.file?.type === "pdf" && res?.data?.file?.stream) {
        let pdf = {
          file: `data:application/pdf;base64,${res?.data?.file?.stream}`,
          file_name: res?.data?.file?.name || "AU_Warranties_Invoice",
        };

        const pdfLink = `${pdf.file}`;
        const anchorElement = document.createElement("a");
        const fileName = `${pdf.file_name}.pdf`;
        anchorElement.href = pdfLink;
        anchorElement.download = fileName;
        anchorElement.click();
      }
      return;
    }
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: "error",
    });
    return;
  };

  const onChangePage = (data) => {
    if (data.page === activePage) {
      return;
    }
    getList({ page: data.page });
  };

  const onSelectItm = (data) => {
    setSelectedItem(data);
  };

  const onMakepaid = () => {
    if (
      selectedItem?.item?.data?.state === paidId &&
      selectedItem?.item?.data?.transactionid
    ) {
      toaster.create({
        title: "card payment can not be marked as paid",
        type: "error",
      });
      return;
    }

    setIsLoading(true);

    api
      .updateInvoicepaid({
        invoiceid: selectedItem?.item?.data?.invoiceid,
        action: selectedItem?.item?.data?.state === paidId ? "pendding" : "",
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          toaster.create({
            title: res?.data?.message,
            type: "success",
          });
          getList();
        } else {
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onChangeFlLast = (data) => {
    setFilerLast(data?.list ? [...data.list] : []);

    if (data?.action !== "useState") {
      if (data?.item?.key) {
        getList({
          limitId: data.item?.key,
          page: 1,
        });
      }
    }

    const appcatch = storage.get("appcatch") || {};
    appcatch.invoices_limitkey = data?.item?.key;
    storage.set("appcatch", appcatch);
  };

  const onChangeDatesDD = (data) => {
    let selDateV = "";
    setDatesDd(data?.list ? [...data.list] : []);

    if (data?.item?.data?.invoicedate) {
      selDateV = utils.dateToDateInput(data.item.data.invoicedate);
      setDate(selDateV);
    } else {
      setDate("");
    }

    const appcatch = storage.get("appcatch") || {};
    appcatch.invoices_fdate = data?.item?.data?.invoicedate;
    storage.set("appcatch", appcatch);

    if (data?.action !== "useState") {
      if (data?.item?.value === "all") {
        getList({
          date: "-1",
          action: data?.action,
          page: 1,
        });
        return;
      }
      if (data?.item?.label) {
        getList({
          date: selDateV,
          action: data?.action,
          page: 1,
        });
      } else {
        getList();
      }
    }
  };

  const onChangeSearchTxt = (v) => {
    setSearchTxt(v);
    getList({ searchTxt: v, dealerid: utils.getDealerid(dealers), page: 1 });
  };

  const getList = async (data) => {
    setSelectedItem();

    const gdata = genPl(data);

    setIsLoading(true);
    return api.getInvoices(gdata).then(async (res) => {
      let newList = [];
      if (res?.status === 200) {
        if (data?.page) {
          setActivePage(data.page);
        }
        if (res?.data && res?.data[0]?.invoiceid) {
          const statesList = { ...constant.statesObj };

          const l = res.data.map((item) => {
            let st = "";
            if (
              item?.state &&
              statesList &&
              statesList[item?.state]?.statename
            ) {
              st = statesList[item?.state]?.statename;
            }

            let paiddate2 = "";
            let paidby2 = "";
            if (item?.paiddate) {
              let pbc = "";
              if (item?.transactionid) {
                pbc = "Card";
              }
              paiddate2 = utils.formatToDDMMYYYY(item.paiddate);
              paiddate2 += " " + pbc;
              paidby2 = item?.paidby || "";

              // ListBox1.AddRow(
              // rs.Field("invoicenumber").StringValue,
              // rs.Field("statename").StringValue,
              // str(dt.day) + "-" + str(dt.month) + "-" + str(dt.year),
              // str(paiddate.day) + "-" + str(paiddate.month) + "-" + str(paiddate.year) + " " + pbc,
              // rs.Field("paidby").StringValue,
              // rs.Field("companyname").StringValue,
              // rs.Field("details").StringValue,
              // format(rs.Field("gross" ).DoubleValue,"#.00"))
            }

            return {
              id: item.invoiceid,
              InvoiceNumber: item.invoicenumber,
              State: st,
              Date: item.invoicedate
                ? utils.formatToDDMMYYYY(item.invoicedate)
                : "",
              Paid: paiddate2,
              By: paidby2, //item?.payment_operator ?? "",
              Retailer: item?.companyname || "",
              Details: item.details || "",
              gross: utils.formatAmountForTb(item.gross),
              data: item,
            };
          });
          setList(l);
          newList = l;
        } else {
          setList([]);
        }
        await getInvoicesTotals(genPl(data));
      } else {
        setList([]);
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }

      setIsLoading(false);
      return newList;
    });
  };

  const getDates = async (data) => {
    setIsLoading(true);
    return api.getInvoicedates().then((res) => {
      setIsLoading(false);
      if (res?.status === 200) {
        if (res?.data && res?.data[0]?.invoicedate) {
          const datesss = res.data.map((a, index) => ({
            key: `dates-${index}`,
            value: `${a?.invoicedate}-${index}`,
            label: utils.formatToDDMMYYYY(a?.invoicedate),
            data: a,
          }));

          const arr = [
            {
              key: "dealer-all",
              value: "all",
              label: "All",
              data: {},
            },
            ...datesss,
          ];

          let result = {
            action: data?.action,
            index: 0,
            item: arr[0],
            list: arr,
          };

          result.list = arr.map((a, index) => {
            if (a?.data?.invoicedate === data?.defaultVal) {
              // a.selected = true;
              result.index = index;
              result.item = a;
            }
            a.selected = false;
            return a;
          });

          if (result?.list && result.list[result?.index]) {
            result.list[result?.index].selected = true;
          }

          onChangeDatesDD(result);
        } else {
          onChangeDatesDD({
            action: data?.action,
          });
        }
      } else {
        onChangeDatesDD({
          action: data?.action,
        });
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  const onDealersChange = (data) => {
    setDealers(data?.list ? [...data.list] : []);

    // if (data?.action === "useState") {
    // setDealerId(data?.item?.data?.dealerid || "");
    // } else {
    // setDealerId(data?.item?.label || "");
    // }

    if (data?.action !== "useState") {
      if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
        getList({
          dealerid: data?.item?.data?.dealerid,
          action: data?.action,
          page: 1,
        });
      } else {
        getList();
      }
    } else {
      const appcatch = storage.get("appcatch") || {};
      getList({
        action: "useState",
        limitId: appcatch?.invoices_limitkey,
        date: appcatch?.invoices_fdate,
        dealerid: data?.item?.data?.dealerid, // appcatch?.invoices_dealerid,
      });
    }

    const appcatch = storage.get("appcatch") || {};
    appcatch.invoices_dealerid = data?.item?.data?.dealerid;
    storage.set("appcatch", appcatch);
  };

  const getInvoicesTotals = async (data) => {
    setIsLoading(true);
    return api.getInvoicesTotals(data).then((res) => {
      setIsLoading(false);
      if (res?.status === 200) {
        setTtlInvoice(res?.data?.totalinvoice || 0);
        setTtlInvoiceVat(res?.data?.totalinvoicevat || 0);
        setTtlPaid(res?.data?.totalpaid || 0);
        setTtlPaidVat(res?.data?.totalpaidvat || 0);
        setTtlPending(res?.data?.totalpending || 0);
        setTtlPendingVat(res?.data?.totalpendingvat || 0);
      } else {
        setTtlInvoice(0);
        setTtlInvoiceVat(0);
        setTtlPaid(0);
        setTtlPaidVat(0);
        setTtlPending(0);
        setTtlPendingVat(0);
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  const onPayClick = () => {
    const payingInvoice2 = selectedItem?.item?.data;
    let loginRes2 = window.localStorage.getItem("loginRes");
    loginRes2 = loginRes2 ? JSON.parse(loginRes2) : {};
    payingInvoice2.payment_operator = loginRes2?.userid;

    console.log("onPayClick", {
      gross: payingInvoice2?.gross,
      invoicenumber: payingInvoice2?.invoicenumber,
      invoiceid: payingInvoice2?.invoiceid,
      userid: payingInvoice2?.userid,
      payment_operator: payingInvoice2?.payment_operator,
    });

    if (selectedItem && payingInvoice2.state !== paidId) {
      if (!payingInvoice2?.gross) {
        toaster.create({
          title: "invoice gross total is not valid. please try again",
          type: "error",
        });
      } else if (
        payingInvoice2?.invoicenumber &&
        payingInvoice2?.invoiceid &&
        payingInvoice2?.userid &&
        // && payingInvoice2.stripe_customerid
        payingInvoice2?.payment_operator
      ) {
        setPayingInvoice(payingInvoice2);
        setIsPaymentModalOpen(true);
      } else {
        toaster.create({
          title: "something went wrong. please try again",
          type: "error",
        });
      }
    }
  };

  const onModalClose = () => {
    const previouslyPayingInvoiceId = payingInvoice?.invoiceid;
    setPayingInvoice(null);
    getList().then((refreshedList) => {
      const refreshedInvoice = refreshedList.find(
        (inv) => inv.id === previouslyPayingInvoiceId
      );
      if (refreshedInvoice && refreshedInvoice?.data?.state === paidId) {
        toaster.create({
          title: "Payment successful!",
          type: "success",
        });
      } else if (previouslyPayingInvoiceId) {
        // toaster.create({
        //   title: "Payment status not updated. Please check again later.",
        //   type: "error",
        // });
      }
    });
  };

  useEffect(() => {
    if (!isPaymentModalOpen && payingInvoice) {
      onModalClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaymentModalOpen]);

  useEffect(() => {
    const cd = async () => {
      const appcatch = storage.get("appcatch") || {};
      setSelectedItem();

      utils.getLimitDD({
        onChangeFlLast: onChangeFlLast,
        action: "useState",
        defaultVal: appcatch?.invoices_limitkey,
      });

      await getDates({
        action: "useState",
        defaultVal: appcatch?.invoices_fdate,
      });

      await utils.getDealers({
        action: "useState",
        onDealersChange,
        setIsLoading,
        defaultVal: appcatch?.invoices_dealerid,
      });
    };

    cd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Invoices"} isLoading={isLoading} />

      <Flex
        width={"100%"}
        flexFlow={"wrap"}
        gap={"1rem"}
        alignItems={"center"}
        mb={"1rem"}
      >
        {/* {loginRes.usertype === 1 ? (
          <ButtonComp
            label="Run Again"
            onClick={onRunAgain}
            disabled={
              !selectedItem ||
              selectedItem?.item?.data?.state === paidId ||
              isLoading
            }
          />
        ) : null} */}
        <DropDown items={datesDd} onChange={onChangeDatesDD} w={"8rem"} />
        <DropDown items={filerLast} onChange={onChangeFlLast} w={"8rem"} />
        <DropDown items={dealers} onChange={onDealersChange} />
        <ButtonComp
          label="Pay"
          onClick={onPayClick}
          disabled={
            !selectedItem ||
            selectedItem?.item?.data?.state === paidId ||
            isLoading
          }
        />
        <Flex flex={1} />
        <ButtonComp
          label="Print"
          keyname="print"
          onClick={onPrint}
          disabled={!selectedItem || isLoading}
        />
        <ButtonComp
          label={
            selectedItem?.item?.data?.state === paidId
              ? "Mark as Unpaid"
              : "Mark as Paid"
          }
          onClick={onMakepaid}
          disabled={!selectedItem || isLoading}
        />
        <ButtonComp
          onClick={() => onPrint({ isallprint: true })}
          disabled={!(list && list[0]?.id) || isLoading}
          label="Print All"
          keyname="print"
        />

        <SearchInput placeholder="Search" onChange={onChangeSearchTxt} />
      </Flex>

      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        selectedItem={selectedItem}
      />

      <PaginationComp
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
        limit={utils.getLimitId(filerLast)}
      />

      <Flex mt={"1rem"} flexFlow={"wrap"} gap={"1rem"} overflow={"scroll"}>
        <CardAmount
          color={"fontdark"}
          data={{
            label1: "Total Invoiced",
            value1: ttlInvoice,
            label2: "Vat",
            value2: ttlInvoiceVat,
          }}
        />
        <CardAmount
          color={"orange"}
          data={{
            label1: "Pending",
            value1: ttlPending,
            label2: "Vat",
            value2: ttlPendingVat,
          }}
        />
        <CardAmount
          color={"green2"}
          data={{
            label1: "Paid",
            value1: ttlPaid,
            label2: "Vat",
            value2: ttlPaidVat,
          }}
        />
      </Flex>
      <Modal
        isopen={isPaymentModalOpen}
        setIsOpen={setIsPaymentModalOpen}
        title="Invoice Payment"
        Child={PaymentIframe}
        childData={{ itemData: payingInvoice }}
      />
    </Flex>
  );
}

export default Invoices;
